import { useState, FormEvent } from 'react';

export default function Contact() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState<'idle' | 'success' | 'error'>('idle');

  const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus('idle');

    try {
      const formBody = new URLSearchParams();
      formBody.append('name', formData.name);
      formBody.append('email', formData.email);
      formBody.append('subject', formData.subject);
      formBody.append('message', formData.message);

      const response = await fetch('https://readdy.ai/api/form/d50q9eiopjgqftil4hg0', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: formBody.toString()
      });

      if (response.ok) {
        setSubmitStatus('success');
        setFormData({ name: '', email: '', subject: '', message: '' });
      } else {
        setSubmitStatus('error');
      }
    } catch (error) {
      setSubmitStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    setFormData(prev => ({
      ...prev,
      [e.target.name]: e.target.value
    }));
  };

  return (
    <section id="contact" className="bg-[#1C1C1E] py-32">
      <div className="max-w-7xl mx-auto px-8">
        <div className="text-center mb-16">
          <span className="text-xs uppercase tracking-widest text-gray-400 font-medium mb-6 block">CONTACT</span>
          <h2 className="font-serif text-6xl md:text-7xl text-white leading-tight">
            Let's Start<br />
            A Literary<br />
            Conversation
          </h2>
        </div>

        <div className="max-w-2xl mx-auto">
          <form id="contact-form" data-readdy-form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <input
                type="text"
                name="name"
                value={formData.name}
                onChange={handleChange}
                placeholder="Your Name"
                required
                className="w-full h-14 bg-[#2C2C2E] border border-gray-700 rounded-xl px-5 text-white placeholder-gray-500 focus:outline-none focus:border-teal-600 transition-colors"
              />
            </div>

            <div>
              <input
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                placeholder="Your Email"
                required
                className="w-full h-14 bg-[#2C2C2E] border border-gray-700 rounded-xl px-5 text-white placeholder-gray-500 focus:outline-none focus:border-teal-600 transition-colors"
              />
            </div>

            <div>
              <input
                type="text"
                name="subject"
                value={formData.subject}
                onChange={handleChange}
                placeholder="Subject"
                required
                className="w-full h-14 bg-[#2C2C2E] border border-gray-700 rounded-xl px-5 text-white placeholder-gray-500 focus:outline-none focus:border-teal-600 transition-colors"
              />
            </div>

            <div>
              <textarea
                name="message"
                value={formData.message}
                onChange={handleChange}
                placeholder="Your Message"
                required
                maxLength={500}
                rows={6}
                className="w-full bg-[#2C2C2E] border border-gray-700 rounded-xl px-5 py-4 text-white placeholder-gray-500 focus:outline-none focus:border-teal-600 transition-colors resize-vertical"
              ></textarea>
              <p className="text-xs text-gray-500 mt-2 text-right">{formData.message.length}/500 characters</p>
            </div>

            {submitStatus === 'success' && (
              <div className="bg-teal-600/20 border border-teal-600 text-teal-400 px-4 py-3 rounded-lg text-sm">
                Thank you for your message! I'll get back to you soon.
              </div>
            )}

            {submitStatus === 'error' && (
              <div className="bg-red-600/20 border border-red-600 text-red-400 px-4 py-3 rounded-lg text-sm">
                Something went wrong. Please try again.
              </div>
            )}

            <div className="flex gap-5 pt-4">
              <button
                type="submit"
                disabled={isSubmitting}
                className="flex-1 bg-white text-gray-900 h-14 rounded-full font-medium hover:bg-gray-100 transition-all duration-300 disabled:opacity-50 disabled:cursor-not-allowed whitespace-nowrap"
              >
                {isSubmitting ? 'Sending...' : 'Send Message'}
              </button>
              <button
                type="button"
                className="flex-1 bg-transparent border-2 border-white text-white h-14 rounded-full font-medium hover:bg-white hover:text-gray-900 transition-all duration-300 whitespace-nowrap"
              >
                Schedule Call
              </button>
            </div>
          </form>
        </div>
      </div>
    </section>
  );
}
